module.exports = __webpack_public_path__ + "media/images/8-59eb1646.png";